import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ServiceProviderSymbol } from '@wix/thunderbolt-symbols'
import { ConsentPolicyService } from './consentPolicyService'

export const site: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(ConsentPolicyService)
}

export const editor = site
